/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_Step4Inputs */

const en_gc_resources_guide_formulas_step4 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change A2 to 90. A5 should update to 220 and B2 to OK. Save an XLSX copy when you finish.`)
};

const zh_gc_resources_guide_formulas_step4 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 A2 改为 90。A5 应更新为 220，B2 应显示 OK。完成后保存 XLSX 副本。`)
};

/**
* | output |
* | --- |
* | "Change A2 to 90. A5 should update to 220 and B2 to OK. Save an XLSX copy when you finish." |
*
* @param {Gc_Resources_Guide_Formulas_Step4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_step4 = /** @type {((inputs?: Gc_Resources_Guide_Formulas_Step4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_Step4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_step4(inputs)
	return zh_gc_resources_guide_formulas_step4(inputs)
});
export { gc_resources_guide_formulas_step4 as "gc.resources.guide.formulas.step4" }